<ng-template #tooltipTpl>
  <div class="kz-post-options--menu">
    <kz-field inline="false" absErrorMsg="true" *ngIf="isAdmin">
      <kz-checkbox-toggle [checkboxToggleState]="blacklistSubmitted ? 'loading' : 'default'" checkboxToggleSize="small">
        <input #checkbox id="kz-post-options--blacklist"
               type="checkbox"
               name="kz-post-options--blacklist"
               [(ngModel)]="post.blacklisted"
               [disabled]="blacklistSubmitted"
               (change)="toggleBlacklisted()">
        <label for="kz-post-options--blacklist" labelRight i18n="@@postPreview.options.blacklist">Blacklisted</label>
      </kz-checkbox-toggle>
    </kz-field>
    <kz-field inline="false" absErrorMsg="true" *ngIf="isAdmin">
      <kz-checkbox-toggle [checkboxToggleState]="pinnedSubmitted ? 'loading' : 'default'" checkboxToggleSize="small">
        <input #checkbox id="kz-post-options--pin"
               type="checkbox"
               name="kz-post-options--pin"
               [(ngModel)]="post.pinned"
               [disabled]="pinnedSubmitted"
               (change)="togglePinned()">
        <label for="kz-post-options--pin" labelRight i18n="@@postPreview.options.pin">Pinned</label>
      </kz-checkbox-toggle>
    </kz-field>
    <div>
      <button class="kz-post-options--report"
              (click.appAccessControl)="!!$event && report()"
              [appAccessControlException]="[role.Reader]"
              [ngClass]="{'kz-button--loading': reportSubmitted}"
              [disabled]="reportSubmitted"
              *ngIf="!userLoggedIsPostAuthor">
        <kz-icons name="alert_triangle"></kz-icons>
        <span i18n="@@postPreview.options.report">Report</span>
      </button>
      <button class="kz-post-options--edit"
              (click)="edit()"
              *ngIf="(userLoggedIsPostAuthor || isAdmin) && !post.totalVotes"
              [ngClass]="{'kz-button--loading': editSubmitted}"
              [disabled]="editSubmitted">
        <kz-icons name="pen"></kz-icons>
        <span i18n="@@postPreview.options.modify">Edit</span>
      </button>
      <button class="kz-post-options--delete"
              (click)="delete()"
              *ngIf="userLoggedIsPostAuthor || isAdmin"
              [ngClass]="{'kz-button--loading': deleteSubmitted}"
              [disabled]="deleteSubmitted">
        <kz-icons name="trashcan"></kz-icons>
        <span i18n="@@postPreview.options.delete">Delete</span>
      </button>
    </div>
  </div>
</ng-template>
<ng-container (appAccessControl)="isAllowed=$event;">
  <button class="kz-post-options"
          [class.showOption]="optionMenuDisplay">
    <kz-icons
      name="gear"
      [kzTooltip]="tooltipTpl"
      tooltipPosition="bottom-right"
      [tooltipAutoOpen]="false"
      [tooltipAutoClose]="false"
      [tooltipOffsetLeft]="12"
      (click)="optionMenuToggle()"
      aria-hidden="true" ></kz-icons>
  </button>
</ng-container>
